export default __webpack_public_path__ + "static/media/HomeWhite.ad62f78c.svg";